module.exports = __webpack_public_path__ + "static/media/polyquity.eab61610.png";